import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { ZaaAutofocusDirective } from '@shared/directives/zaa-autofocus/zaa-autofocus.directive';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  selector: 'app-input-app',
  templateUrl: './input-app.component.html',
})
export class InputAppComponent {
  @Input({required: true}) ACCOUNT_TYPES!: Array<any>;
  @Input({required: true}) formGroup!: FormGroup;
}
